import { StylesConfig } from 'react-select';
import { OptionType } from 'components/CustomSelect/types';

const AllocationMethodSelectorStyles: StylesConfig<OptionType, false> = {
  option: styles => ({
    ...styles,
    fontWeight: 600,
  }),
};

export default AllocationMethodSelectorStyles;
